import React, { memo } from "react";
import styled from "styled-components";
import PauseIcon from "@material-ui/icons/Pause";
import CheckIcon from "@material-ui/icons/Check";
import LocalDining from "@material-ui/icons/LocalDining";
import CloseRounded from "@material-ui/icons/CloseRounded";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import PaymentIcon from "@material-ui/icons/Payment";
import Warning from "@material-ui/icons/PriorityHighRounded";
import Info from "@material-ui/icons/Info";
import RestaurantGroup from "../../assets/images/restaurant-group";
import {
  setBackgroundColorIcon,
  setTextColorIcon,
} from "../../helpers/set-color";

interface IProps {
  icon: string | "";
  backgroundColor?: string;
  textColor?: string;
  size?: string;
  border?: boolean | false;
  position?: string;
}

interface IStyled {
  backgroundColor?: string;
  textColor?: string;
  size?: string | "small";
  border?: boolean | false;
  position?: string;
}

const RoundedIconWrapper = styled.div<IStyled>`
  position: ${(props) =>
    props.position === "tag" || props.position === "legend"
      ? "relative"
      : "absolute"};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: ${(props) => setSize(props.size)};
  min-width: ${(props) => setSize(props.size)};
  height: ${(props) => setSize(props.size)};
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "white"};
  color: ${(props) =>
    props.textColor ? props.textColor : props.theme.textColorGray};
  border: 1px solid
    ${(props) => (props.border ? props.textColor : "transparent")};
  top: ${(props) => setTopPosition(props.position, props.size)};
  left: ${(props) => setLeftPosition(props.position, props.size)};
  right: ${(props) => (props.position === "left" ? "" : "-4px")};
  margin: 0 2px;

  svg {
    width: ${(props) => setSVGSize(props.size)};
    height: ${(props) => setSVGSize(props.size)};
  }

  @media screen and (max-width: 768px) {
    margin-right: 2px;
    margin-top: 2px;
  }
`;

const setSize = (size?: string) => {
  switch (size) {
    case "large":
      return "32px";
    case "normal":
      return "24px";
    case "legend":
      return "20px";
    default:
      return "12px";
  }
};

const setSVGSize = (size?: string) => {
  switch (size) {
    case "large":
      return "24px";
    case "normal":
      return "16px";
    default:
      return "10px";
  }
};

const setTopPosition = (position?: string, size?: string) => {
  switch (position) {
    case "left":
      return size === "large" ? "-12px" : "-4px";
    case "right":
      return "-4px";
    default:
      return 0;
  }
};

const setLeftPosition = (position?: string, size?: string) => {
  switch (position) {
    case "left":
      return size === "large" ? "-12px" : "-4px";
    case "right":
      return "";
    default:
      return 0;
  }
};

const renderIcon = (icon: string) => {
  switch (icon) {
    case "waiting":
      return <PauseIcon />;
    case "warning":
    case "message":
      return <Warning />;
    case "error":
    case "Error":
      return <CloseRounded />;
    case "flash-on-icon":
      return <FlashOnIcon />;
    case "payment-icon":
      return <PaymentIcon />;
    case "info":
      return <Info />;
    case "success":
      return <CheckIcon />;
    case "restaurant-group":
      return <RestaurantGroup />;
    default:
      return <LocalDining />;
  }
};

const RoundedIconDef = (props: IProps) => {
  return (
    <RoundedIconWrapper
      backgroundColor={setBackgroundColorIcon(props.icon)}
      textColor={setTextColorIcon(props.icon)}
      size={props.size}
      border={props.border}
      position={props.position}
      data-test="status-icon"
    >
      {renderIcon(props.icon)}
    </RoundedIconWrapper>
  );
};

export const RoundedIcon = memo(RoundedIconDef);
